import React, { Component } from 'react'
import { Navbar, Nav, Button } from 'react-bootstrap'
import auth from '../../functions/auth'
import { Link, withRouter } from 'react-router-dom';

class NavBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userRole: '',
    }
  }
  componentWillMount() {
    this.setState({ userRole: localStorage.getItem('username') || '', })
  }
  Logout = () => {
    auth.logout(() => {
      this.props.history.push('/');
    });
  };
  render() {
    let { pathname } = this.props.location;
    let showPath = pathname.charAt(1).toUpperCase() + pathname.slice(2);
    return (
      <div>
        <Navbar>
          <Navbar.Brand><h1>{showPath}</h1></Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text>
              Signed in as: {this.state.userRole}
            </Navbar.Text>
          </Navbar.Collapse>

        </Navbar>
        <Navbar>
          <Navbar.Collapse className="justify-content-end">
            {
              pathname === '/adminsys'? <Link to="admin"><Button variant="outline-primary">กลับสู่หน้าหลัก</Button></Link> : <Link to="adminsys"><Button variant="outline-primary">ระบบผู้ดูแล</Button></Link>
            }
            
            <Button variant="danger" onClick={this.Logout}>ออกจากระบบ</Button>
          </Navbar.Collapse>

        </Navbar>
      </div>
    )
  }
}

export default withRouter(NavBar);
